/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountEphemeralCredentialsForAzureCsp extends models.ServiceAccountEphemeralCredentialsBaseForAzure {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountEphemeralCredentialsForAzureCsp");
    }

    getFixupPrototypeFunction() { return ServiceAccountEphemeralCredentialsForAzureCsp.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountEphemeralCredentialsForAzureCsp>): ServiceAccountEphemeralCredentialsForAzureCsp {
        let obj = Object.assign(new ServiceAccountEphemeralCredentialsForAzureCsp(), model);
        ServiceAccountEphemeralCredentialsForAzureCsp.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountEphemeralCredentialsForAzureCsp>): ServiceAccountEphemeralCredentialsForAzureCsp {
        if (!model) return null;
        return ServiceAccountEphemeralCredentialsForAzureCsp.newInstance(<ServiceAccountEphemeralCredentialsForAzureCsp> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountEphemeralCredentialsForAzureCsp) {
        if (!obj) return;

        models.ServiceAccountEphemeralCredentialsForAzureCsp.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountEphemeralCredentialsForAzureCsp): boolean {
        if (models.ServiceAccountEphemeralCredentialsBaseForAzure.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountEphemeralCredentialsForAzureCsp.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Access Token
     */
    access_token: string;

}
